import {Dimensions, StyleSheet} from 'react-native';
const {width} = Dimensions.get('window');

const Colors = {
  mBackColor: '#efefef',
  mBorderColor: '#efefef',
  white: '#FFFFFF',
  shadowColor: '#A69E9E',
};

const Metrics = {
  containerWidth: width - 30,
  switchWidth: width / 2.7,
};
export default StyleSheet.create({
  formContainer: {
    padding: 8,
    flex: 1,
  },
  displayHorizontal: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'stretch',
    flexWrap: 'wrap',
  },
  containers: {
    width: Metrics.containerWidth,
    height: 55,
    flexDirection: 'row',
    backgroundColor: Colors.mBackColor,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: Colors.mBorderColor,
    borderRadius: 27.5,
  },
  button: {
    margin: 15,
    color: '#fff',
    padding: 10,
    paddingLeft: 30,
    paddingRight: 30,
    backgroundColor: '#69bbea',
  },
  container: {
    marginVertical: 8,
  },
  input: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 5,
    paddingVertical: 5,
    paddingLeft: 5,
    fontSize: 16,
    height: 40,
    color: '#c0cbd3',
  },
  info: {
    backgroundColor: 'black',
    width: 20,
    borderRadius: 15,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  colorWhite: {
    zIndex: 9999,
    color: 'white',
  },
  App: {
    textAlign: 'left',
    paddingTop: 10,
  },
  label: {
    marginRight: 20,
    marginLeft: 20,
    marginTop: 10,
    marginBottom: 10,
    fontSize: 16,
    fontWeight: 'normal',
    color: 'black',
  },
  bold: {
    fontWeight: 'bold',
  },
  textError: {
    color: '#f00',
    fontSize: 14,
  },
  item: {
    marginBottom: 14,
  },
  btnValiderOuter: {
    minWidth: 130,
    // width: windowDim * 0.02,
    backgroundColor: '#0f579e',
    borderRadius: 30,
    height: 50,
    paddingHorizontal: 4,
    shadowColor: 'rgba(15, 87, 158, 0.9)',
    shadowOffset: {
      width: 1,
      height: 2,
    },
    shadowOpacity: 0.4,
    shadowRadius: 7,
    elevation: 5,
    marginVertical: 8,
    flexGrow: 0,
    flexShrink: 1,
  },
  btnValider: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '700',
    textAlign: 'center',
    paddingHorizontal: 4,
    marginHorizontal: 8,
  },
  btnAnnuler: {
    color: '#58A618',
    fontSize: 16,
    fontWeight: '700',
    textAlign: 'center',
    paddingHorizontal: 0,
    marginHorizontal: 8,
  },
  btnAnnulerOuter: {
    minWidth: 120,
    backgroundColor: '#F9FCFF',
    borderRadius: 30,
    paddingHorizontal: 4,
    borderWidth: 1,
    borderColor: 'rgba(240, 244, 248, 0.875)',
    shadowColor: '#fafafa',
    shadowOffset: {
      width: 1,
      height: 2,
    },
    shadowOpacity: 0.01,
    shadowRadius: 0,
    elevation: 0,
    marginVertical: 8,
    flexGrow: 0,
    flexShrink: 1,
  },
  closeBtn: {
    position: 'absolute',
    top: -15,
    right: -15,
    textAlign: 'right',
  },
  addBtn: {
    // backgroundColor: 'red',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  submitButtonsContainer: {
    marginTop: -20,
    paddingLeft: 30,
    marginBottom: 5,
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  noFlexGrow: {
    flexShrink: 0,
    flexGrow: 0,
    flexBasis: 'auto',
  },
});
